import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BackgroundPaths } from "../../components/ui/background-paths";
import { Helmet } from "react-helmet";

export default function LandingPage() {
  const navigate = useNavigate();
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Auto-redirect after 4 seconds (matching animation duration) with fade-out transition
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(true);
      // Wait for fade-out animation before navigating
      setTimeout(() => {
        navigate("/job-search-browse");
      }, 500);
    }, 1300); // Changed to exactly 1300ms (1.3s)

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleDiscoverClick = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      navigate("/job-search-browse");
    }, 500);
  };

  return (
    <>
      <Helmet>
        <title>Welcome to GradOne - Graduate Job Board</title>
        <meta
          name="description"
          content="Discover your perfect graduate role with GradOne - the UK's leading AI-powered job board for early-career professionals"
        />
      </Helmet>

      <div className="landing-page-wrapper" onClick={handleDiscoverClick}>
        <BackgroundPaths
          title="Welcome to GradOne"
          isTransitioning={isTransitioning}
        />
      </div>
    </>
  );
}